import { createAction, props } from '@ngrx/store';

export const updateQuickForm = createAction(
  '[QuickReplies] Update Form',
  props<{ formData: any }>()
);

export const goToNextQuickResponse = createAction(
  '[QuickReplies] Navigate To Next Response',
  props<{ nextResponse: any }>()
);


// initialisation
export const resetQuickRepliesStates = createAction('[QuickReplies] Reset State');
// Reset quick replies for a specific response
export const resetQuickRepliesState = createAction(
  '[QuickReplies] Reset State',
  props<{ responseId: string }>()
);

export const cacheQuickReplyState = createAction(
  '[Quick Replies] Cache Quick Reply State',
  props<{ responseId: string; quickReplyState: any }>()
);

export const loadQuickReplyStateFromCache = createAction(
  '[Quick Replies] Load Quick Reply State From Cache',
  props<{ responseId: string }>()
);

export const clearQuickReplyCache = createAction(
  '[Quick Replies] Clear Quick Reply Cache',
  props<{ responseId: string }>()
);